/** In-app Commander Medical Readiness Portal (static Figma prototype). */
export const COMMANDER_READINESS_ROUTE = '/commander-readiness';

/** Static testKey for dashboard card → Commander Readiness. */
export const COMMANDER_READINESS_TEST_KEY = 'commander_readiness';

/** High Level Commander — Command Readiness Summary portal (static Figma prototype). */
export const COMMANDER_READINESS_SUMMARY_ROUTE = '/commander-readiness-summary';

/** Static testKey for dashboard card → High Level Commander Summary. */
export const COMMANDER_READINESS_SUMMARY_TEST_KEY = 'commander_readiness_summary';
